import type { EffectiveThemeMode, ThemeMode } from "./palette";

import * as React from "react";

import { resolveEffectiveMode } from "./palette";

const MEDIA_QUERY = "(prefers-color-scheme: dark)";

function usePrefersDarkColorScheme(): boolean {
  const [prefersDark, setPrefersDark] = React.useState(() => {
    return typeof window !== "undefined" && window.matchMedia
      ? window.matchMedia(MEDIA_QUERY).matches
      : false;
  });

  // eslint-disable-next-line replo/no-use-effect -- Subscribes to the OS/browser theme setting.
  React.useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) {
      return;
    }
    const mediaQueryList = window.matchMedia(MEDIA_QUERY);
    const handleChange = (event: MediaQueryListEvent) => {
      setPrefersDark(event.matches);
    };
    setPrefersDark(mediaQueryList.matches);
    mediaQueryList.addEventListener("change", handleChange);
    return () => {
      mediaQueryList.removeEventListener("change", handleChange);
    };
  }, []);

  return prefersDark;
}

// Resolves the concrete rendering mode for a given theme mode. When the user
// picked "system" this returns light/dark based on the device preference and
// re-renders when it changes; otherwise it echoes the given mode.
export function useEffectiveThemeMode(mode: ThemeMode): EffectiveThemeMode {
  const prefersDark = usePrefersDarkColorScheme();
  return resolveEffectiveMode({ mode, prefersDark });
}
